class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[options][fields]=title,body,vendor,product_type,variants.sku,tag&resources[limit]=4&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter','open-search-drawer');    
  });
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','open-search-drawer');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
    });
  });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search','open-search-drawer');
  }
};



document.addEventListener('DOMContentLoaded', () => {
  const searchIcon = document.querySelector('.searchlist .search-icon');

  if (!searchIcon) return;

  searchIcon.addEventListener('click', () => {
    document.body.classList.add('open-search-drawer');
    setTimeout(() => {
      document.querySelector('.snippet-search-bar #Search')?.focus();
    }, 100);
  }); 
});


function updateHeaderHeight() {
    const shopifySectionAnnouncementBar = document.querySelector('#shopify-section-announcement-bar');
    const shopifySectionHeader = document.querySelector('#shopify-section-header');
    
    const headerHeight = shopifySectionHeader?.offsetHeight || 0;
    const announcementHeight = shopifySectionAnnouncementBar?.offsetHeight || 0;
    const allHeaderHeight = headerHeight + announcementHeight;
    
    document.documentElement.style.setProperty('--announcement-height',`${announcementHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${allHeaderHeight}px`);
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

updateHeaderHeight();

const debouncedUpdate = debounce(updateHeaderHeight, 100);
window.addEventListener('resize', debouncedUpdate);



document.addEventListener('DOMContentLoaded', function () {
  var menu = document.getElementById('categoryMenu');
  if (!menu) return;

  menu.querySelectorAll('.list-categories-submenu input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var url = cb.getAttribute('data-url');
      if (url) window.location.href = url;
    });
  });
});


// document.addEventListener("DOMContentLoaded", function () {

//   console.log("DOM Loaded");

//   function checkLoyaltyDiscountDiv() {
//     const loyaltyDiv = document.querySelector(".wc_loyalty_apply_discount_cart");
//     console.log("Div Found:", loyaltyDiv);
//     if (!loyaltyDiv) {
//       // console.log("Div not found");
//       return;
//     }
//     // console.log("Div HTML:", loyaltyDiv.innerHTML);
//     // console.log("Div Text:", loyaltyDiv.textContent.trim());
//     if (
//       loyaltyDiv.innerHTML.trim() === "" ||
//       loyaltyDiv.textContent.trim() === ""
//     ) {
//       console.log("Div is blank");
//       if (typeof window.rivyoLoyaltyCartDiscount === "function") {
//         // console.log("Function found, calling now...");
//         window.rivyoLoyaltyCartDiscount();
//       } else {
//         // console.log("window.rivyoLoyaltyCartDiscount is NOT available");
//       }
//     } else {
//       // console.log("Div already has content");
//     }
//   }
//   setTimeout(function () {
//     // console.log("Checking after timeout...");
//     checkLoyaltyDiscountDiv();
//   }, 1000);

// });


document.addEventListener("click", function (e) {
  if (e.target.closest(".rivyo-reward-button")) {
    e.preventDefault();
    e.stopPropagation();
    console.log("Form submit stopped");
  }
});


function checkLoyaltyDiscountDiv() {

  console.log("Checking loyalty div...");

  const loyaltyDiv = document.querySelector(".wc_loyalty_apply_discount_cart");

  console.log("Div Found:", loyaltyDiv);

  if (!loyaltyDiv) {
    console.log("Div not found");
    return;
  }

  console.log("Div HTML:", loyaltyDiv.innerHTML);

  if (
    loyaltyDiv.innerHTML.trim() === "" ||
    loyaltyDiv.textContent.trim() === ""
  ) {

    console.log("Div is blank");

    if (typeof window.rivyoLoyaltyCartDiscount === "function") {

      console.log("Calling rivyoLoyaltyCartDiscount()");
      window.rivyoLoyaltyCartDiscount();

    } else {

      console.log("Function not found");

    }

  } else {

    console.log("Div already has content");

  }
}


window.addEventListener("load", function () {

  console.log("Window Loaded");
  checkLoyaltyDiscountDiv();

});

document.addEventListener("click", function (e) {
  const headerCart = e.target.closest(".header-cart");
  if (headerCart) {
    console.log(".header-cart clicked");
    setTimeout(function () {
      checkLoyaltyDiscountDiv();
    }, 500);

  }

});